<template>
    <div class="col-12">
        <ul class="list-1">
            <li v-for="(item, i) in list" :key="i">{{ item }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
        },
    },
}
</script>